/*
 * The factory's WhatsApp link, shared by the footer and the mobile menu.
 *
 * It lives on its own because the number inside it also has to agree with the
 * `tel:` link in the footer, and a phone number written out in three places is
 * a phone number that will eventually disagree with itself.
 *
 * Digits only and with the country code — the format wa.me requires. The
 * prefilled text is a suggestion; WhatsApp drops it into the compose box and
 * the sender can still edit or clear it.
 */
export const WHATSAPP_URL =
  "https://wa.me/5585994320868?text=" +
  encodeURIComponent("Olá! Gostaria de saber mais sobre os produtos da Pemalex.")
